import React from 'react';
import { Link } from 'react-router-dom';
export function NewsfilateFooter() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-white text-gray-900 py-12 border-t border-gray-100" data-id="element-409">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-410">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-411">
          <div className="col-span-1 md:col-span-2" data-id="element-412">
            <div className="mb-4" data-id="element-413">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/3eb2f218-c9ff-4fe6-ad82-ebadfcc155d3/Nf_final.png" alt="Newsfiliate Logo" className="h-10" data-id="element-414" />
            </div>
            <p className="text-gray-600 mb-4 max-w-md" data-id="element-415">
              Helping newsletter creators effortlessly monetize with Amazon
              affiliate deals and promo codes.
            </p>
          </div>
          <div data-id="element-416">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4" data-id="element-417">
              Product
            </h3>
            <ul className="space-y-2" data-id="element-418">
              <li data-id="element-419">
                <a href="#features" className="text-gray-600 hover:text-gray-900" onClick={e => scrollToSection(e, 'features')} data-id="element-420">
                  Features
                </a>
              </li>
              <li data-id="element-421">
                <a href="#how-it-works" className="text-gray-600 hover:text-gray-900" onClick={e => scrollToSection(e, 'how-it-works')} data-id="element-422">
                  How It Works
                </a>
              </li>
              <li data-id="element-423">
                <a href="#pricing" className="text-gray-600 hover:text-gray-900" onClick={e => scrollToSection(e, 'pricing')} data-id="element-424">
                  Pricing
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-425">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4" data-id="element-426">
              Company
            </h3>
            <ul className="space-y-2" data-id="element-427">
              <li data-id="element-428">
                <Link to="/" className="text-gray-600 hover:text-gray-900" data-id="element-429">
                  Creator Boost
                </Link>
              </li>
              <li data-id="element-430">
                <a href="https://datadyno.blog" className="text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer" data-id="element-431">
                  Blog
                </a>
              </li>
              <li data-id="element-432">
                <a href="https://newsfiliate.creatorboost.ai/doc/newsfiliate-help?page=support" className="text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer" data-id="element-433">
                  Support
                </a>
              </li>
              <li data-id="element-434">
                <a href="https://creatorboost.ai/privacy-policy" className="text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer" data-id="element-435">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-436">
                <a href="https://creatorboost.ai/terms-of-service" className="text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer" data-id="element-437">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-100 text-center text-gray-600 text-sm" data-id="element-438">
          <p data-id="element-439">
            &copy; {new Date().getFullYear()} Newsfiliate. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}